import { useMemo, useState } from "react";
import { projects, projectTypes, projectYears } from "../data/projects";
import { ProjectCard } from "../components/ProjectCard";

const Chip = ({ active, children, ...rest }) => (
  <button
    {...rest}
    className={`rounded-sm border px-3 py-1.5 text-xs transition-colors ${
      active
        ? "border-[#FF4D00] bg-[#FF4D00] text-white"
        : "border-border text-muted-foreground hover:border-foreground hover:text-foreground"
    }`}
  >
    {children}
  </button>
);

export default function Work() {
  const [type, setType] = useState("all");
  const [year, setYear] = useState("all");

  const filtered = useMemo(
    () =>
      projects.filter(
        (p) =>
          (type === "all" || p.type === type) &&
          (year === "all" || String(p.year) === String(year))
      ),
    [type, year]
  );

  return (
    <div className="mx-auto max-w-6xl px-6 pb-10 pt-16 sm:px-10 sm:pt-24" data-testid="work-page">
      <p className="font-mono-label mb-5">Work</p>
      <h1 className="max-w-2xl text-4xl font-extrabold leading-[1.05] sm:text-5xl">
        Every project, start to finish.
      </h1>

      <div className="mt-14 space-y-5 border-y border-border py-6">
        <div className="flex flex-wrap items-center gap-2" data-testid="work-filter-type">
          <span className="font-mono-label mr-2 w-12">Type</span>
          <Chip active={type === "all"} onClick={() => setType("all")} data-testid="filter-type-all">
            All
          </Chip>
          {projectTypes.map((t) => (
            <Chip
              key={t}
              active={type === t}
              onClick={() => setType(t)}
              data-testid={`filter-type-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              {t}
            </Chip>
          ))}
        </div>
        <div className="flex flex-wrap items-center gap-2" data-testid="work-filter-year">
          <span className="font-mono-label mr-2 w-12">Year</span>
          <Chip active={year === "all"} onClick={() => setYear("all")} data-testid="filter-year-all">
            All
          </Chip>
          {projectYears.map((y) => (
            <Chip key={y} active={String(year) === String(y)} onClick={() => setYear(y)} data-testid={`filter-year-${y}`}>
              {y}
            </Chip>
          ))}
        </div>
      </div>

      <p className="font-mono-label mt-6" data-testid="work-result-count">
        {filtered.length} project{filtered.length === 1 ? "" : "s"}
      </p>

      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((p, i) => (
          <ProjectCard key={p.slug} project={p} index={i} />
        ))}
      </div>

      {filtered.length === 0 && (
        <p className="py-20 text-sm text-muted-foreground" data-testid="work-empty-state">
          No projects match those filters.
        </p>
      )}
    </div>
  );
}
